import one from '../../assets/1.svg';
import two from '../../assets/2.svg';
import three from '../../assets/3.svg';
import four from '../../assets/4.svg';

export default [{
    id: 1,
    title: 'Welcome',
    description: 'Participate in fun activities, Play games with friends, challenge them and enjoy funfilled activities error free. SWIPE to know more',
    img: {one}
  },
  {
    id: 2,
    title: 'Play Games',
    description: 'Play your favourite games or choose different activities',
    img: {two}
  },
  { 
    id: 3,
    title: 'Challenge',
    description: 'Challenge your friends and play against them. You can also team up with them.',
    img: {three}
  },
  { 
    id: 4,
    title: 'Participate in a hackathon!',
    description: 'Participate in a hackathon, use your skills, have fun, meet new people!',
    img: {four}
  }
];